import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_CATEGORY_RESULTS_FAIL = 'LOAD_CATEGORY_RESULTS_FAIL';
export type LOAD_CATEGORY_RESULTS_FAIL_ACTION = TypedActionWithPayload<typeof LOAD_CATEGORY_RESULTS_FAIL, string>;

export const LOAD_CATEGORY_RESULTS_REQUEST = 'LOAD_CATEGORY_RESULTS_REQUEST';
export type LOAD_CATEGORY_RESULTS_REQUEST_ACTION = TypedActionWithPayload<typeof LOAD_CATEGORY_RESULTS_REQUEST>;

export const LOAD_CATEGORY_RESULTS_SUCCESS = 'LOAD_CATEGORY_RESULTS_SUCCESS';
export type LOAD_CATEGORY_RESULTS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_CATEGORY_RESULTS_SUCCESS,
    {
        queryId: string;
        usedIndex: string;
    }
>;
